import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import process from "./views/process .vue"
import cooperate from './views/cooperate.vue'
import weChat from './views/weChat.vue'
import cash from './views/cash.vue'     //收银机客显广告位
import business from './views/business.vue' //商务合作
import businessProduct from './views/businessProduct.vue'   //商家后台产品
import smallProgramProduct from './views/smallProgramProduct.vue'   //微信小程序产品
import publicNumberProduct from './views/publicNumberProduct.vue'   //公众号产品   
import dispose from './views/dispose.vue'   //配置   
import about from './views/About.vue'
import VersionControlTable from './views/VersionControlTable.vue'   //配置
import aboutour from './views/Aboutour.vue'   //关于我们
import course from './views/course.vue'   //使用教程

Vue.use(Router)

export default new Router({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }, {
      path: "/process",
      name: "process",
      component: process
    }, {
      path: "/retail",
      name: "retail",
      component: () => import('./views/retail.vue')
    }, {
      path: "/wholesaler",
      name: "wholesaler",
      component: () => import('./views/wholesaler.vue')
    }, {
      path: "/warehouse",
      name: "warehouse",
      component: () => import('./views/warehouse.vue')
    }, {
      path: "/money",
      name: "money",
      component: () => import('./views/money.vue')
    },
    {
      path: '/cooperate',
      name: 'cooperate',
      component: cooperate
    },
    {
      path: '/weChat',
      name: 'weChat',
      component: weChat
    },
    {
      path: '/cash',
      name: 'cash',
      component: cash
    },
    {
      path: '/business',
      name: 'business',
      component: business
    },
    {
      path: '/businessProduct',
      name: 'businessProduct',
      component: businessProduct
    },
    {
      path: '/smallProgramProduct',
      name: 'smallProgramProduct',
      component: smallProgramProduct
    },
    {
      path: '/publicNumberProduct',
      name: 'publicNumberProduct',
      component: publicNumberProduct
    },
    {
      path: '/dispose',
      name: 'dispose',
      component: dispose
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/VersionControlTable',
      name: 'VersionControlTable',
      component: VersionControlTable
    },
    {
      path: '/aboutour',
      name: 'aboutour',
      component: () => import('./views/Aboutour.vue')
    }, {
      path: "/course",
      name: "course",
      component: course,
      children: [
        {
          path: "/course/help",
          name: "help",
          component: () => import('./views/help.vue')
        },
        {
          path: "/course/shop",
          name: "shop",
          component: () => import('./components/video/shop.vue')
        }
      ]
    },
  ],
  scrollBehavior (to, from, savedPosition) { //页面回退 原来位置不变
    if (savedPosition) {        
          return savedPosition    
    } else {      
          if (from.meta.keepAlive) {        
               from.meta.savedPosition = document.body.scrollTop;      
          }        
          return { x: 0, y: to.meta.savedPosition || 0 }    
    }  
  }
})
